import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import Grid from "@mui/material/Grid";

import React, { useEffect, useState } from "react";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import {} from "../../utils/utils";
// import Youtube from '../assets/img/icon/youtube.png'
import Youtube from "../../assets/img/icon/youtube.png";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShareIcon from "@mui/icons-material/Share";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
// import { GetBussiness, UpdateBusiness } from "./myBusinessApi";

import AddLocationIcon from "@mui/icons-material/AddLocation";
import { formDataFN, swalAlertPopProps } from "../../utils/commonUtils";
// import { validationsSubmits } from "./myBusinessValidationFunctions";
import { FormGroup } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import ApModal from "../../common/AppoinmetModalppBtn";
import MediaModel from "../../common/mediaModel";
import MediaModelApp from "../../common/mediaModelApp";
import MediaCardInput from "../../common/mediaCardInput";
import PersonIcon from "@mui/icons-material/Person";
import { cityNameCll } from "../landingPage/landingPageApi";
import ImageUploader from "../../common/imageUpload";
import { formDataFn } from "../../common/commonUtils/commonUtilFunction";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import MultipleImageInput from "../../common/imgUploadMul";
import { GetBussiness, UpdateBusiness } from "../myBusiness/myBusinessApi";
import { validationsSubmits } from "../myBusiness/myBusinessValidationFunctions";
import {
  getInstitute,
  institueAdd,
  institueUpdate,
} from "../myInstitute/instituteApi";
import {
  franchiseAddAdd,
  franchiseImgUpdate,
  getFranchiseImg,
} from "./franchiseAPI";
import Heading from "../../common/Heading";
// import { getInstitute, institueAdd, institueUpdate } from "./instituteApi";

export default function UploadImage(instituteId) {
  const struct = {
    // id: 4,
    billerId: 0,
  };

  const [institute, setInstitute] = useState({ ...struct });

  const [hide, setHide] = useState(false);

  const userDetail = useSelector((state) => state.reducer.userDetail);

  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));

  const getData = async () => {
    const payload = { billerId: billerId || userDetail?.userMasterId };

    getFranchiseImg(payload, (res) => {
      const obj = res?.data?.data?.list?.[0];
      if (!obj) {
        // NO DATA → RESET FORM FOR ADD
        setInstitute({ ...struct, billerId });
        return;
      }

      setInstitute(obj);

      // console.log(obj);
    });

    // console.log("ll", institute?.instituteName);
  };

  function optionVal(data) {
    if (!data) return "";

    const dataColl = [
      "google",
      "website",
      "instagram",
      "facebook",
      "youTube",
      "pinterest",
      "twitter",
      "linkedIn",
    ];

    const selected = dataColl.filter((key) => data[key]);
    return selected.length ? selected.join(", ") : " ";
  }

  const submit = async () => {
    let obj = {
      Id: institute?.id || 0,
      //  File: institute.File,

      //  File: selectedImages,
    };
    // selectedImages.forEach((ele, index) => {
    //   obj["File" + (index == 0 ? "" : index + 1)] = ele.file
    //     ? ele.file
    //     : ele.url;
    // });

    if (institute.ImageFile instanceof File) {
      obj.ImageFile = institute.ImageFile;
    }

    let payload = formDataFN(obj);

    if (!institute?.id) {
      await franchiseAddAdd(payload, () => {
        getData();
      });
    } else {
      await franchiseImgUpdate(payload, () => {
        getData();
      });
    }
  };
  useEffect(() => {
    getData();
  }, []);
  // return <h1>fet</h1>
  return (
    <Grid
      container
      px={{ sm: 4, xs: 2 }}
      pb={4}
      sx={{
        paddingTop: "15px",
        backgroundColor: "#E3E3FF",
        minHeight: "100vh",
      }}
    >
      {/* <DynamicBreadcrumbs /> */}

      <Grid item xs={12}>
        <Heading name="Upload Image" />

        {/* <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px 15px",
              mt: { sm: "10px", xs: "1px" },
              borderRadius: "5px",
              color: "#01008B", // optional text color
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },

              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "20px" },
              }}
            >
              Upload Image
            </Typography>
          </Grid>
        </Grid> */}
        <Grid
          container
          spacing={1}
          sx={{
            margin: 0,
            padding: { xs: "0px", sm: "20px" },
            borderRadius: "10px",
            backgroundColor: "#fff",
            maxHeight: "80vh",
            overflow: "auto",
            pr: { xs: 1, sm: 4 },
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item xs={8}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {institute?.logoPreview ? (
                  // ✅ NEW IMAGE PREVIEW
                  <Box
                    component="img"
                    src={institute.logoPreview}
                    alt="Preview"
                    onClick={() =>
                      document.getElementById("imageUpload").click()
                    }
                    sx={{
                      width: { xs: "100px", sm: "150px" },
                      height: { xs: "100px", sm: "150px" },
                      cursor: "pointer",
                      // borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                ) : institute?.image ? (
                  // ✅ EXISTING IMAGE FROM API
                  <Box
                    component="img"
                    src={institute.image}
                    alt="Existing"
                    onClick={() =>
                      document.getElementById("imageUpload").click()
                    }
                    sx={{
                      width: { xs: "100px", sm: "150px" },
                      height: { xs: "100px", sm: "150px" },
                      cursor: "pointer",
                      // borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  // ✅ NO IMAGE
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() =>
                      document.getElementById("imageUpload").click()
                    }
                    sx={{
                      position: "relative",
                      justifyContent: "center",
                    }}
                  >
                    {/* Icon on the left */}
                    <AddAPhotoOutlinedIcon
                      sx={{
                        position: "absolute",
                        left: 16,
                      }}
                    />
                    Attach Image
                  </Button>
                )}

                <input
                  type="file"
                  id="imageUpload"
                  style={{ display: "none" }}
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      setInstitute((prev) => ({
                        ...prev,
                        ImageFile: file,
                        logoPreview: URL.createObjectURL(file), // ✅ THIS drives preview
                      }));
                    }
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "40%",
                mx: "auto",
              }}
            >
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={submit}
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1,
                  fontSize: { xs: "12px", sm: "13px", md: "16px" },
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                Upload
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>

      {/* <ApModal open={} setOpen={} /> */}
      {institute != null && (
        <MediaModelApp
          open={hide}
          setOpen={setHide}
          modelData={{
            google: "",
            website: "",
            instagram: "",
            facebook: "",
            youTube: "",
            pinterest: "",
            twitter: "",
            linkedIn: "",
            ...institute,
          }}
          setModalData={setInstitute}
        />
      )}
    </Grid>
  );
}
